import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import {
  getPartyList,
  createTrip
} from "../../../store/actions/tripActionCreator";
import {
  getAllLocations
} from "../../../store/actions/homeActionCreator";
import { getVehicleLedgerData, getAllDrivers } from "../../../store/actions/vehicleActionCreator";
import * as logger from "../../../logger";
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat } from '../../../utils/utils'
import AddIcon from '@material-ui/icons/Add';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { sendError, sendSucces } from "../../../utils/utils"
import useStyles from '../css/forms';
import BootstrapInput from '../../components/Inputs/inputs';
import { Form } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Autocomplete
} from 'mui-rff';
import {
  Typography,
  Paper,
  Link,
  Grid,
  Button,
  Card,
  CardActions,
  CardContent,
  CssBaseline,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormControl,
  CardHeader,
  TextField as TextInput,
  Checkbox
} from '@material-ui/core';
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import AddParty from '../Parties/AddParty';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}
const validate = values => {
  const errors = {};
  if (!values.party) {
    errors.party = 'Please Select a Party';
  }
  if (!values.vehicle) {
    errors.vehicle = 'Required';
  }
  if (!values.origin) {
    errors.origin = 'Required';
  }
  if (!values.destination) {
    errors.destination = 'Required';
  }
  if (!values.amount && values.partyBillingType == 'Fixed') {
    errors.amount = 'Required';
  }
  if (!values.startDate) {
    errors.startDate = 'Required';
  }
  if (!values.partyBillingType) {
    errors.partyBillingType = 'Required';
  }
  if (!values.unitPrice && values.partyBillingType != 'Fixed') {
    errors.unitPrice = 'Required';
  }
  if (!values.totalUnits && values.partyBillingType != 'Fixed') {
    errors.totalUnits = 'Required';
  }
  return errors;
};
var pageConfig = require("./trips.json");
const filter = createFilterOptions();
const AddTrip = ({
  user, trip, dispatchGetPartyListAction, vehicle, dispatchGetVehicleLedgerAction,
  dispatchGetAllLocations,
  dispatchCreateTrip
}) => {
  const classes = useStyles();
  let history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [vehicleListOpen, setvehicleListOpen] = React.useState(false);
  const [sourceListOpen, setSourceListOpen] = React.useState(false);
  const [destinationListOpen, setDestinationListOpen] = React.useState(false);

  const [options, setOptions] = React.useState([]);
  const [vehicleListOptions, setVehicleListOptions] = React.useState([]);
  const [allLocations, setAllLocations] = React.useState([]);
  //const [destinationListoptions, setDestinationListOptions] = React.useState([]);

  //Party
  const [partyValue, setPartyValue] = React.useState(null);
  const [partyBillingTypeValue, setPartyBillingTypeValue] = React.useState(null);
  const [vehicleValue, setVehicleValue] = React.useState(null);
  const [sourceValue, setSourceValue] = React.useState(null);
  const [destinationValue, setDestinationValue] = React.useState(null);
  const [addPartyOpen, toggleAddPartyOpen] = React.useState(false);
  const [addVehicleOpen, toggleAddVehicleOpen] = React.useState(false);
  const [partyDialogValue, setPartyDialogValue] = React.useState({
    name: '',
    number: '',
  });
  const [vehicleDialogValue, setVehicleDialogValue] = React.useState({
    name: '',
    number: '',
  });
  const loading = open && options.length === 0;
  const vehicleLoading = vehicleListOpen && vehicleListOptions.length === 0;
  const sourceLoading = sourceListOpen && allLocations.length === 0;
  const destinationLoading = destinationListOpen && allLocations.length === 0;
  const goToTripView = (data) => {
    history.push({
      pathname: `/trips/view/${data.id}`,
      state: {
        id: 7,
        tripData: data,
        tripView: true,
        pageTitle: 'Trip Details',
        pageSubTitle: data && data.vehicleNumber ? data.vehicleNumber : ''
      }
    });
  }
  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    let createTripData = {
      totalAmount: Number(values.amount),
      tripStartDate: Math.round(((new Date(values.startDate).getTime()) / 1000)),
      customerId: values.party,
      destinationLocation: values.destination,
      sourceLocation: values.origin,
      vehicleId: values.vehicle,
      fleetOwnerId: user.userInfo.entityId,
      billingType: values.partyBillingType,
    }
    if (values.partyBillingType != 'Fixed') {
      createTripData['billingDetails'] = { unitPrice: Number(values.unitPrice), totalUnits: Number(values.totalUnits) }
      createTripData['totalAmount'] = Number(values.unitPrice ? values.unitPrice : 0) * Number(values.totalUnits ? values.totalUnits : 0);
    }
    //billingDetails
    dispatchCreateTrip(
      createTripData,
      (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces('Trip created successfully')
          goToTripView(response.response)
        }
        logger.log("Create Trip deweb Component", "------> Create Trip Success", response);
      },
      () => {
        sendError('Trip Creation Failed')
        logger.log("Create Trip dweb Component", "------> Create Trip Failure");
      }
    )
  };
  const handleAddPartyClose = () => {
    setPartyDialogValue({
      name: '',
      number: '',
    });
    toggleAddPartyOpen(false);
  };
  const handlePartySave = (status) => {
  }
  const handleAddVehicleClose = () => {
    setVehicleDialogValue({
      name: '',
      number: '',
    });
    toggleAddVehicleOpen(false);
  };
  const handleVehicleSave = (status) => {
  }
  React.useEffect(() => {
    let active = true;
    let vehicleActive = true;
    let sourceActive = true;
    let locationActive = true;
    if (loading) {
      (async () => {
        const response = await dispatchGetPartyListAction(
          null,
          () => {
          },
          () => {
          }
        );
        await sleep(1e3); // For demo purposes.
        //const parties = await response.json();

        if (active) {
          setOptions(trip && trip.createTripParties ? trip.createTripParties : []);
        }
      })();

      return () => {
        active = false;
      };
    }
    if (vehicleLoading) {
      (async () => {
        const response = await dispatchGetVehicleLedgerAction({
          fleetOwnerId: user.userInfo.entityId,
          ownershipType: ["SELF", "HIRED"],
          vehicleStatus: ["AVAILABLE", "ONTRIP"],
        },
          (response) => {
          },
          () => {
          }
        );
        await sleep(1e3);
        if (vehicleActive) {
          setVehicleListOptions(vehicle && vehicle.vehicleLedgerData ? vehicle.vehicleLedgerData : []);
        }
      })();
      return () => {
        vehicleActive = false;
      };
    }
    if (sourceLoading || destinationLoading) {
      (async () => {
        const response = await dispatchGetAllLocations(
          () => {
          },
          () => {
          }
        );
        await sleep(1e3);
        if (locationActive) {
          setAllLocations(user && user.allLocations ? user.allLocations : []);
        }
      })();
      return () => {
        locationActive = false;
      };
    }
    return undefined;
  }, [loading, vehicleLoading, sourceLoading, destinationLoading]);
  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
    if (!vehicleListOpen) {
      setVehicleListOptions([]);
    }
    if (!sourceListOpen || !destinationListOpen) {
      setAllLocations([]);
    }
  }, [open, vehicleListOpen, sourceListOpen, destinationListOpen]);
  const tripDetails = [
    {
      size: 6,
      visible: true,
      field: (
        <Autocomplete
          classes={{
            listbox: classes.listBoxAutoCompelete,
            option: classes.listBoxOption
          }
          }
          id="select-party-list"
          //label="Party"
          name="party"
          size="small"
          //placeholder="Select a Party"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'string') {
              // timeout to avoid instant validation of the dialog's form.
              setTimeout(() => {
                toggleAddPartyOpen(true);
                setPartyDialogValue({
                  name: typeof Number(newValue) != 'number' ? newValue : "",
                  number: typeof Number(newValue) == 'number' ? newValue : "",
                });
              });
            } else if (newValue && newValue.inputValue) {
              toggleAddPartyOpen(true);
              setPartyDialogValue({
                name: typeof Number(newValue.inputValue) != 'number' ? newValue.inputValue : "",
                number: typeof Number(newValue.inputValue) == 'number' ? newValue.inputValue : "",
              });
            } else if (newValue && newValue.inputValue === '') {
              toggleAddPartyOpen(true);
              setPartyDialogValue({
                name: typeof Number(newValue.inputValue) != 'number' ? newValue.inputValue : "",
                number: typeof Number(newValue.inputValue) == 'number' ? newValue.inputValue : "",
              });
            } else {
              setPartyValue(newValue);
            }
          }}
          getOptionSelected={(option, value) => option.customerId === value.customerId}
          required={true}
          autoHighlight
          freeSolo
          options={options ? options : []}
          loading={loading}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          getOptionValue={option => option.customerId}
          //getOptionLabel={option => option.name}
          getOptionLabel={(option) => {
            // e.g value selected with enter, right from the input
            if (typeof option === 'string') {
              return option;
            }
            if (option.inputValue) {
              return option.inputValue;
            }
            return option.name
          }}
          disableCloseOnSelect={false}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            filtered.unshift({
              inputValue: params.inputValue,
              name: params.inputValue && params.inputValue.length > 1 ? `Add Details for"${params.inputValue}"` : `Add New Party`,
            });
            /*if (params.inputValue !== '') {
              filtered.push({
                inputValue: params.inputValue,
                name: `Add Details for"${params.inputValue}"`,
              });
            }*/

            return filtered;
          }}
          renderOption={(option, { selected, inputValue }) => {
            let matchesName, matchesNumber;
            let partsName, partsNumber;
            matchesName = match(option.name, inputValue);
            partsName = parse(option.name, matchesName);
            matchesNumber = match(option.contactNumber, inputValue);
            partsNumber = parse(option.contactNumber, matchesNumber);

            if (option && option.customerId) {
              return (
                <div className={classes.partyListItem}>
                  {partsName.map((part, index) => {
                    return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                      {part.text}
                    </span>
                    )
                  })}
                  {option.contactNumber && <>
                    <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                    {partsNumber.map((part, index) => {
                      return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                        {part.text}
                      </span>
                      )
                    })}
                  </>}
                </div>
              );

            } else {
              return (
                <div className={classes.partyAddListItem}>
                  <AddPersonIcon className={classes.addPersonIcon} />
                  {partsName.map((part, index) => {
                    return (<span key={index} style={{ fontWeight: 300, color: '#fff' }}>
                      {part.text}
                    </span>
                    )
                  })}
                  <ChevronRightIcon className={classes.cherveRightIcon} />
                </div>
              );
            }

          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select a Party"
              placeholder="Select a Party"
              variant="outlined"
              name="party"
              margin='normal'
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          multiple={false}
        />
      ),
    },
    {
      size: 6,
      visible: true,
      field: (
        <Autocomplete
          classes={{
            listbox: classes.listBoxAutoCompelete,
            option: classes.listBoxOption
          }
          }
          id="select-vehicle-list"
          name="vehicle"
          size="small"
          open={vehicleListOpen}
          onOpen={() => {
            setvehicleListOpen(true);
          }}
          onClose={() => {
            setvehicleListOpen(false);
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'string') {
              // timeout to avoid instant validation of the dialog's form.
              setTimeout(() => {
                toggleAddVehicleOpen(true);
                setVehicleDialogValue({
                  name: typeof Number(newValue) != 'number' ? newValue : "",
                  number: typeof Number(newValue) == 'number' ? newValue : "",
                });
              });
            } else if (newValue && newValue.inputValue) {
              toggleAddVehicleOpen(true);
              setVehicleDialogValue({
                name: typeof Number(newValue.inputValue) != 'number' ? newValue.inputValue : "",
                number: typeof Number(newValue.inputValue) == 'number' ? newValue.inputValue : "",
              });
            } else if (newValue && newValue.inputValue === '') {
              toggleAddVehicleOpen(true);
              setVehicleDialogValue({
                name: typeof Number(newValue.inputValue) != 'number' ? newValue.inputValue : "",
                number: typeof Number(newValue.inputValue) == 'number' ? newValue.inputValue : "",
              });
            } else {
              setVehicleValue(newValue);
            }
          }}
          getOptionSelected={(option, value) => option.id === value.id}
          required={true}
          autoHighlight
          freeSolo
          options={vehicleListOptions}
          loading={vehicleLoading}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          getOptionValue={option => option.id}
          //getOptionLabel={option => option.name}
          getOptionLabel={(option) => {
            // e.g value selected with enter, right from the input
            if (typeof option === 'string') {
              return option;
            }
            if (option.inputValue) {
              return option.inputValue;
            }
            return option.vehicleNumber
          }}
          disableCloseOnSelect={false}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            filtered.unshift({
              inputValue: params.inputValue,
              vehicleNumber: params.inputValue && params.inputValue.length > 1 ? `Add Details for"${params.inputValue}"` : `Add New Vehicle`,
            });
            return filtered;
          }}
          renderOption={(option, { selected, inputValue }) => {
            //let matchesName,matchesNumber;
            //let partsName,partsNumber;
            //matchesName = match(option.vehicleNumber, inputValue);
            //partsName = parse(option.vehicleNumber, matchesName);
            //matchesNumber = match(option.contactNumber, inputValue);
            //partsNumber = parse(option.contactNumber, matchesNumber);

            if (option && option.id) {
              return (
                <div className={classes.partyListItem}>
                  <span>{option.vehicleNumberPrefix}
                    <span className={classes.vehicleNumberSuffix}>{option.vehicleNumberSuffix}</span>
                    {option.lastLocation && <>
                      <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                      {option.lastLocation}
                    </>}
                    <span className={classes.listRight}>
                      <span className={option.ownershipType && option.ownershipType == 'HIRED' ? classes.hired : classes.own}>{option.ownershipType && option.ownershipType == 'HIRED' ? 'Market' : 'Own'}</span>
                      <span className={classes.vehicleStatus}><FiberManualRecordIcon className={option.status && option.status == 'ONTRIP' ? classes.onTripBullet : classes.avilableBullet}></FiberManualRecordIcon>{option.status}</span>
                    </span>
                  </span>
                </div>
              );

            } else {
              return (
                <div className={classes.partyAddListItem}>
                  <AddPersonIcon className={classes.addPersonIcon} />
                  <span>{option.vehicleNumber}</span>
                  <ChevronRightIcon className={classes.cherveRightIcon} />
                </div>
              );
            }

          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select a Vehicle"
              placeholder="Select a Vehicle"
              variant="outlined"
              name="vehicle"
              margin='normal'
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {vehicleLoading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          multiple={false}
        />
      ),
    }
  ];
  const routeDetails = [
    {
      size: 6,
      visible: true,
      field: (
        <Autocomplete
          classes={{
            listbox: classes.listBoxAutoCompelete,
            option: classes.listBoxOption
          }
          }
          style={{ marginRight: 20 }}
          id="select-source-list"
          //label="Party"
          name="origin"
          size="small"
          //placeholder="Select a Party"
          open={sourceListOpen}
          onOpen={() => {
            setSourceListOpen(true);
          }}
          onClose={() => {
            setSourceListOpen(false);
          }}
          onChange={(event, newValue) => { }}
          getOptionSelected={(option, value) => option.name === value.name}
          required={true}
          autoHighlight
          freeSolo
          options={allLocations ? allLocations : []}
          loading={sourceLoading}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          getOptionValue={option => option.name}
          //getOptionLabel={option => option.name}
          getOptionLabel={(option) => {
            // e.g value selected with enter, right from the input
            if (typeof option === 'string') {
              return option;
            }
            if (option.inputValue) {
              return option.inputValue;
            }
            return option.name
          }}
          disableCloseOnSelect={false}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            return filtered;
          }}
          renderOption={(option, { selected, inputValue }) => {
            let matchesName = match(option.name, inputValue);
            let partsName = parse(option.name, matchesName);
            if (option && option.name) {
              return (
                <div className={classes.partyListItem}>
                  {partsName.map((part, index) => {
                    return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                      {part.text}
                    </span>
                    )
                  })}
                  {option.state && <>
                    <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                    {option.state}
                  </>}
                </div>
              );

            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select a Origin"
              placeholder="Select a Origin"
              variant="outlined"
              name="origin"
              margin='normal'
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {sourceLoading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          multiple={false}
        />
      ),
    },
    {
      size: 6,
      visible: true,
      field: (
        <Autocomplete
          classes={{
            listbox: classes.listBoxAutoCompelete,
            option: classes.listBoxOption
          }
          }
          id="select-destination-list"
          name="destination"
          size="small"
          style={{ marginLeft: 20 }}
          open={destinationListOpen}
          onOpen={() => {
            setDestinationListOpen(true);
          }}
          onClose={() => {
            setDestinationListOpen(false);
          }}
          onChange={(event, newValue) => { }}
          getOptionSelected={(option, value) => option.name === value.name}
          required={true}
          autoHighlight
          freeSolo
          options={allLocations ? allLocations : []}
          loading={destinationLoading}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          getOptionValue={option => option.name}
          //getOptionLabel={option => option.name}
          getOptionLabel={(option) => {
            // e.g value selected with enter, right from the input
            if (typeof option === 'string') {
              return option;
            }
            if (option.inputValue) {
              return option.inputValue;
            }
            return option.name
          }}
          disableCloseOnSelect={false}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            return filtered;
          }}
          renderOption={(option, { selected, inputValue }) => {
            let matchesName = match(option.name, inputValue);
            let partsName = parse(option.name, matchesName);
            if (option && option.name) {
              return (
                <div className={classes.partyListItem}>
                  {partsName.map((part, index) => {
                    return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                      {part.text}
                    </span>
                    )
                  })}
                  {option.state && <>
                    <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                    {option.state}
                  </>}
                </div>
              );

            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select a Destination"
              placeholder="Select a Destination"
              variant="outlined"
              name="destination"
              margin='normal'
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {destinationLoading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
          multiple={false}
        />
      ),
    }
  ];
  const getBillingDetails = (values) => {
    let { partyBillingType } = values;
    let unitsPriceLabel = "";
    let totalUnitsLabel = "";
    if (partyBillingType === 'Per Tonne') {
      unitsPriceLabel = 'Rate Per Tonne';
      totalUnitsLabel = 'Total Tonnage';
    } else if (partyBillingType === 'Per KG') {
      unitsPriceLabel = 'Rate Per Kg';
      totalUnitsLabel = 'Total Kg'
    } else if (partyBillingType === 'Per KM') {
      unitsPriceLabel = 'Rate Per Km';
      totalUnitsLabel = 'Total Km'
    }
    return [
      {
        size: 6,
        visible: partyBillingType == 'Fixed',
        inline: false,
        field: (
          <TextField
            label="Enter a Freight Amount"
            placeholder="Enter a Freight Amount"
            name="amount"
            margin="none"
            fullWidth={false}
            variant="outlined"
            size="small"
            margin="normal"
            required={true}
          />
        ),
      },
      {
        size: 6,
        visible: partyBillingType !== 'Fixed',
        inline: false,
        field: (
          <TextField
            label={unitsPriceLabel}
            placeholder={unitsPriceLabel}
            name="unitPrice"
            margin="none"
            style={{ marginRight: 40 }}
            fullWidth={false}
            variant="outlined"
            size="small"
            margin="normal"
            required={true}
          />
        ),
      },
      {
        size: 6,
        visible: partyBillingType !== 'Fixed',
        inline: false,
        field: (
          <TextField
            label={totalUnitsLabel}
            placeholder={totalUnitsLabel}
            name="totalUnits"
            margin="none"
            fullWidth={false}
            variant="outlined"
            size="small"
            margin="normal"
            required={true}
          />
        ),
      },
      {
        size: 6,
        visible: true,
        field: (
          <div>
            <DatePicker
              disableFuture
              name="startDate"
              margin="normal"
              variant="inline"
              fullWidth={false}
              inputVariant="outlined"
              size="small"
              format="dd-MM-yyyy"
              label="Start Date"
              placeholder="Select a Start Date"
              dateFunsUtils={DateFnsUtils}
              InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
            />
          </div>
        ),
      }
    ]
  }
  return (<Wrapper>
    <Paper className={classes.pageContentDIv} elevation={3}>
      <Form
        onSubmit={onSubmit}
        initialValues={{ partyBillingType: 'Fixed', stooge: 'larry' }}
        validate={validate}
        render={({ handleSubmit, form, submitting, pristine, values }) => (
          <form onSubmit={(event) => {
            const promise = handleSubmit(event);
            promise && promise.then(() => {
              form.reset();
            })
            return promise;
          }} noValidate>
            <Card className={classes.formCard}>
              {/* <CardHeader
                title={pageConfig.childStates.create.formTitle}
                subheader=""
              /> */}
              <CardContent className={classes.formCardContent}>
                <Typography type='body2' className={classes.inputsTitle}>Trip Details</Typography>
                {tripDetails.map((item, idx) => (
                  item.field
                ))}
                <Typography type='body2' className={classes.inputsTitle}>Route</Typography>
                <div className={classes.inlineInput}>
                  {routeDetails.map((item, idx) => (
                    item.field
                  ))}
                </div>
                <Typography type='body2' className={classes.inputsTitle}>Billing Information</Typography>
                <div>
                  <Radios
                    label="Party Billing Type"
                    name="partyBillingType"
                    required={true}
                    formControlProps={{
                      margin: 'normal',
                      className: classes.billingTypeRadio,
                      fullWidth: true
                    }}
                    formControlLabelProps={{
                      className: classes.billingTypeLabel
                    }}
                    formLabelProps={{}}
                    radioGroupProps={{ row: true }}
                    data={[
                      { value: 'Fixed', label: 'Fixed' },
                      { value: 'Per Tonne', label: 'Per Tonne' },
                      { value: 'Per KG', label: 'Per KG' },
                      { value: 'Per KM', label: 'Per KM' }
                    ]}
                  />
                </div>
                {getBillingDetails(values).map((item, idx) => item.visible ? (
                  item.field
                ) : null)}
              </CardContent>
              <CardActions className={classes.formCardActions}>
                <Button
                  type="button"
                  variant="contained"
                  onClick={form.reset}
                  disabled={submitting || pristine}
                >
                  Reset
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={submitting}
                >
                  Save Trip
                </Button>
              </CardActions>
            </Card>
          </form>
        )}
      />
    </Paper>
    {addPartyOpen && <AddParty open={addPartyOpen} defaultName={partyDialogValue.name} defaultNumber={partyDialogValue.number} onClose={handleAddPartyClose} onSave={handlePartySave} />}
  </Wrapper>);
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchLogoutAction: () => dispatch(logoutUser()),
  dispatchGetPartyListAction: (data, onSuccess, onFailure) => dispatch(getPartyList(data, onSuccess, onFailure)),
  dispatchGetVehicleLedgerAction: (requestData, onSuccess, onFailure) => { dispatch(getVehicleLedgerData(requestData, onSuccess, onFailure)) },
  dispatchGetAllLocations: (onSuccess, onFailure) => { dispatch(getAllLocations(onSuccess, onFailure)) },
  dispatchCreateTrip: (data, onSuccess, onFailure) => { dispatch(createTrip(data, onSuccess, onFailure)) },
});
const AddTripWithRouter = withRouter(AddTrip);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddTripWithRouter);